<div class="client_pageBody">
  <div class="page_Title text-xl md:text-2xl font-bold mb-2 md:mb-4">
    {{_common.SpaceBookings}}
  </div>

  <div class="max-height body_section">
    <app-space-search-list></app-space-search-list>
  </div>
</div>
